import ChangeReasonModalComponent from './change-reason-modal-component'

/***
 * A modal that pops up when re-committing Stats data that has already been committed, prompting the user to provide
 * an explanation for why they are changing the data.
 */
const changeReasonModal = angular
    .module('FacilityData.EnterData.ChangeReasonModal', [])
    .component('changeReasonModal', ChangeReasonModalComponent)
    .name;

export default changeReasonModal;


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/change-reason-modal/change-reason-modal.js